import React from "react"

export enum SidePanelStatus {
    loading = "loading",
    failed = "failed",
    uploading = "uploading",
    // Separate case for Colorfinder "uploading" status to show "Uploading" instead of "Processing"
    // Should probably become consistent in other side panel tab types eventually.
    singleFileUploading = "singleFileUploading",
    ready = "ready",
    upload = "upload",
    queued = "queued",
    empty = "empty",
    // Live-scanned flights: images arrive via livescan ingestion, not user upload
    live = "live",
}

/**
 * data: Data Modal / FlightView / Plugin
 * layer: Actual layer content such as video/image set
 */
export type ActiveSidePanelModalType = "data" | "layer"

/**
 * fmv: Full Motion Video
 * vcf: Video Colorfinder
 * icf: Image Colorfinder
 * pano: Panorama
 */
export type LayerContentType = "fmv" | "vcf" | "icf" | "pano" | "live"

export type Modal = {
    id?: string
    type?: ActiveSidePanelModalType
    layerContentType?: LayerContentType
}

export type SidePanelModalActivation = Modal & {
    /**
     * Whether to de-select any selected bounding box on the map.
     * @default true
     */
    deselectBoundingBox?: boolean
}

export const SidePanelProgressBar = ({
    progress,
    total,
    colorHex,
}: {
    progress: number
    total: number
    colorHex: string
}) => {
    const percentage = Math.round(Math.min((progress / total) * 100, 100))
    return (
        <div className="h-0.5 w-full bg-gray-600 overflow-hidden mt-1">
            <div
                className="h-full"
                style={{
                    width: `${percentage}%`,
                    backgroundColor: colorHex,
                    transition: "width 0.3s ease-in-out",
                }}
            />
        </div>
    )
}
